(function () {
  'use strict';

  /* @ngdoc object
   * @name user.connections
   * @description
   *
   */
  angular
    .module('user.connections', [
      'ui.router'
    ]);
}());
